import { Cache, CacheFactory } from 'cachefactory';

export class ViewSettingsCache {

    private static _cache: Cache;
    private static cacheFactory = new CacheFactory();
    private static cacheKey = 'view-config-cache';

    public static get cache(): Cache {
        try {
            if (!this.cacheFactory.exists(this.cacheKey)) {
                this._cache = this.cacheFactory.createCache(this.cacheKey);
            }
            return this._cache;
        } catch (err) {
            throw new Error(err instanceof Error ? err.message : String(err));
        }
    }
}
